import React, {useContext} from 'react';
import {InsuranceContext} from "../InsuranceContext";
import TitleInsurance from "../TitleInsurance";
import InsuranceInput from "../InsuranceInput";
import InsuranceInputHolder from "../InsuranceInput/InsuranceInputHolder";

const InternalResource = () => {
  const helper = useContext(InsuranceContext);
  const setMyData = helper.setMyData
  const myData = helper.myData

  const objectKey = 'internalResources'
  return (<div>
    <TitleInsurance title={'منابع داخلی'}/>

    <div className={'insurance__box border__insurance'}>


      <InsuranceInputHolder

        objectKey={objectKey}
        row={//
          {title: "تاریخ اولین قسط داخلی", type: 'date', name: 'firstInternalDate', required: true,}} //

      />
      <InsuranceInputHolder

        objectKey={objectKey}
        row={//
          {title: "گام اقساط داخلی بر اساس روز", type: 'number', name: 'dayCount', required: true,}//
        }
      />
      <InsuranceInputHolder

        objectKey={objectKey}
        row={//
          {title: "تعداد اقساط داخلی", type: 'string', name: 'internalInstallmentCount', required: true,}//

        }
      />


    </div>

  </div>);
}

export default InternalResource;
